import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {fetchMenusIfNeeded, selectCustomPage,
        fetchCustomPageIfNeeded, CLIENT_BASE_URL} from '../../actions'
// import TeamImage from './TeamImage.png'
import Helmet from "react-helmet";
import {HeaderView} from '../HeaderView/HeaderView'
import {FooterLinks} from '../FooterLinks/FooterLinks'
import {SocialView} from '../SocialView/SocialView'
import {FooterNote} from '../FooterLinks/FooterNote'
import {SearchView} from '../SearchView/SearchView'

export class Template2 extends React.Component {

  constructor (props) {
    super(props)
    this.renderSideBar = this.renderSideBar.bind(this)
    this.gotoPage = this.gotoPage.bind(this)
  }

  drawBackgroundImage (poster) {
    poster = CLIENT_BASE_URL + poster
    return {
      backgroundImage: `url('${poster}')`
    }
  }

  componentWillMount (p) {
    const {match, dispatch} = this.props

    if (Object.keys(match.params).length) {
      dispatch(selectCustomPage(match.params[0]))
      dispatch(fetchCustomPageIfNeeded(match.params[0]))
    } else {
      dispatch(selectCustomPage(''))
    }
  }

  componentDidMount () {
    const {dispatch, match} = this.props
    dispatch(fetchMenusIfNeeded(this.props.selectedScope))
    if (Object.keys(match.params).length) {
      dispatch(selectCustomPage(match.params[0]))
    } else {
      dispatch(selectCustomPage(''))
    }

  }

  componentWillReceiveProps (nextProps) {
    const {match, dispatch} = nextProps
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope))
    }

    const {selectedCustomPage} = this.props

    if (Object.keys(match.params).length && selectedCustomPage !== match.params[0]) {
      dispatch(selectCustomPage(match.params[0]))
      dispatch(fetchCustomPageIfNeeded(match.params[0]))
    }
  }

  componentWillUnmount () {
    const {dispatch} = this.props
    dispatch(selectCustomPage(''))
  }

  renderSideBar (page, topLargeImg, sidebarhtml, mainHtmlClassName, mainhtml) {
    /*
    if (page === 'contactos' || page === 'contatos') {
      return (
        <div className='row main-block' style={{marginLeft: 37}}>
          <div className='col-sm-8 col-md-8' style={{marginTop: 42}}>
            <p className={mainHtmlClassName} dangerouslySetInnerHTML={{ __html: mainhtml }}></p>
          </div>
        </div>
      )
    }
    */

    return (
      <div className='row main-block'>

        <div className='col-sm-4 col-md-3 side-block no-pad'>
          <img className='thumb' src={topLargeImg} />
          {(sidebarhtml !== '' && sidebarhtml !== '<p></p>') ? (
            <div className='desc'>
              <p dangerouslySetInnerHTML={{ __html: sidebarhtml }}></p>
            </div>
            ) : null
          }
        </div>
        <div className='col-sm-8 col-md-offset-1 col-md-8' style={{marginTop: 42}}>
          <p className={mainHtmlClassName} dangerouslySetInnerHTML={{ __html: mainhtml }}></p>
        </div>
      </div>
    )
  }

  gotoPage (page) {
    this.props.history.push('/pesquisa')
  }

  render () {
    const {menus, match, dispatch} = this.props
    const top_menus = menus.top || []
    const bottom_menus = menus.bottom || []

    const {details} = this.props
    if (!Object.keys(details).length) {
      return (
        <div></div>
        )
    }

    let mainHtmlClassName = ''
    if (parseInt(details['0'].num_text_cols, 10) === 2) {
      mainHtmlClassName = 'twocols'
    }

    // <div className='thumb' style={this.drawBackgroundImage(details['0'].poster)}></div>
    const topLargeImg = CLIENT_BASE_URL + details['0'].poster
    let desc = '';

    if (typeof details !== "undefined" && details.length) {
      desc = details['0'].mainhtml
        .replace(/<(?:.|\n)*?>/gm, "")
        .replace(/&nbsp;|\n|\r/gm, " ");
    }

    return (
      <div>
        <Helmet
          title={details['0'].title}
          meta={[
            { name: "description", content: desc },
            {
              property: "og:image",
              content: topLargeImg
            },
            { property: "og:title", content: details['0'].title },
            { property: "og:type", content: "article" },
            {
              property: "og:url",
              content:
                CLIENT_BASE_URL + "/t2/" + this.props.match.params[0]
            }
          ]}
        />
        <HeaderView top_menus={top_menus} dispatch={dispatch}/>
        <div id='about-view' className='row team-view'>
          <div className='col-md-12 no-pad text-left'>
            <p className='left-tag'>{details['0'].title}</p>
            <SearchView gotoPage={this.gotoPage} dispatch={dispatch} customStyle={'alignright'} />
          </div>
          {this.renderSideBar(match.params[0], topLargeImg, details['0'].sidebarhtml,
              mainHtmlClassName, details['0'].mainhtml)
          }
        </div>

        <FooterLinks bottom_menus={bottom_menus}/>
        <SocialView customclass='lite'/>
        <FooterNote />
      </div>
    )
  }
}

Template2.propTypes = {
  dispatch: PropTypes.func.isRequired,

  menus: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  details: PropTypes.object.isRequired,
  selectedCustomPage: PropTypes.string.isRequired,
  selectedScope: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  const {getMenus, selectedCustomPage, getCustomPage, selectedScope} = state

  const {
    isFetchingMenus,
    lastUpdatedMenus,
    items: menus
  } = getMenus[selectedScope] || {
    isFetchingMenus: true,
    items: {}
  }

  const {
    isFetchingCPage,
    items: details
  } = getCustomPage[selectedCustomPage] || {
    isFetchingCPage: true,
    items: {}
  }

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    selectedScope,
    selectedCustomPage,
    isFetchingCPage,
    details
  }
}

export default connect(mapStateToProps)(Template2)



// WEBPACK FOOTER //
// ./src/views/AboutView/Template2.js